import * as React from "react";
import {Component} from "react";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  z-index: 995;
  display: block;
  top: 49px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
`;

const Spinner = styled.div`
  /* Spinner */
  position: fixed;
  z-index: 999;
  width: 50px;
  height: 50px;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  /* :not(:required) hides these rules from IE9 and below */
  &:not(:required) {
    /* hide "loading..." text */
    font: 0/0 a;
    color: red;
    text-shadow: none;
    background-color: blue;
    border: 0;
  }

  /* Animation */
  -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
  animation: sk-rotateplane 1.2s infinite ease-in-out;

  @-webkit-keyframes sk-rotateplane {
    0% {
      -webkit-transform: perspective(120px);
    }
    50% {
      -webkit-transform: perspective(120px) rotateY(180deg);
    }
    100% {
      -webkit-transform: perspective(120px) rotateY(180deg) rotateX(180deg);
    }
  }

  @keyframes sk-rotateplane {
    0% {
      transform: perspective(120px) rotateX(0deg) rotateY(0deg);
      -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    }
    50% {
      transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
      -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
    }
    100% {
      transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
      -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    }
  }
`;

/**
 * A Loading component.
 *
 * This component renders an overlay and a spinner to be used when any blocking action is in progress.
 */
export class LoadingSpinner extends Component {
    public static displayName = "LoadingSpinner";

    /**
     * @override rendering method.
     */
    public render() {
        return (
            <Overlay data-testid={'LoadingSpinner'}>
                <Spinner/>
            </Overlay>
        );
    }
}